import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useTranslation } from "react-i18next";

/** Dismiss, with an optional reason the card then shows as "Why: …". */
export function DismissWithReason({
  busy,
  onDismiss,
}: {
  busy: boolean;
  onDismiss: (note: string | undefined) => void;
}) {
  const { t } = useTranslation();
  const [note, setNote] = useState("");
  return (
    <span className="flex items-center gap-1">
      <input
        className="h-8 w-56 rounded-md border bg-background px-2 text-sm"
        placeholder={t("agentTabs.dismiss.placeholder")}
        aria-label={t("agentTabs.dismiss.ariaLabel")}
        maxLength={1000}
        value={note}
        onChange={(e) => setNote(e.target.value)}
        data-testid="learning-dismiss-reason"
      />
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={busy}
        onClick={() => onDismiss(note.trim() || undefined)}
      >
        {t("agentTabs.dismiss.button")}
      </Button>
    </span>
  );
}
